require('./assets/js/parts/home_atl');